<template>
  <div
    class="shadow-generic-search-box p-4 md:px-6"
    data-test-id="discount-list-item-component"
  >
    <div v-if="isLoading" class="relative flex flex-col animate-pulse w-full">
      <span class="w-2/3 h-3 md:h-5 bg-middle-light mb-1" />
      <span class="w-10/12 h-4 md:h-5 bg-middle-light mb-4" />
      <div class="flex">
        <div class="flex flex-col w-1/2 md:w-auto md:mr-10">
          <span class="w-10 md:w-12 h-3 md:h-5 bg-middle-light mb-1" />
          <span class="w-22 md:w-24 h-5 bg-middle-light" />
        </div>
        <div class="flex flex-col">
          <span class="w-16 md:w-17 h-3 md:h-5 bg-middle-light mb-1" />
          <span class="w-22 md:w-24 h-5 bg-middle-light" />
        </div>
      </div>
    </div>

    <div v-else class="flex flex-col cursor-pointer" @click="goTo">
      <span class="uppercase font-gt-america-extended font-light text-tiniest md:text-smaller leading-3 md:leading-5 text-middle md:mb-1">{{ getCategory }}</span>
      <span class="font-light text-smallest md:text-base leading-4 md:leading-5 mb-4">{{ getTitle }}</span>
      <div class="flex">
        <div v-if="getCity" class="flex flex-col">
          <span class="uppercase font-gt-america-extended font-light text-tiniest md:text-smaller leading-3 md:leading-5 text-middle md:mb-1">{{ $messages('label.location') }}</span>
          <span class="text-infra-violette font-medium text-smaller md:text-base leading-5">{{ getCity }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    discount: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getCategory () {
      return this.discount && this.discount.categories && this.discount.categories[0] && this.discount.categories[0].name
    },
    getTitle () {
      return this.discount && this.discount.title
    },
    getCity () {
      return (this.discount && this.discount.cities && this.discount.cities.length > 1)
        ? this.$messages('label.multiple')
        : (this.discount.cities.length === 1)
            ? this.discount.cities[0].name
            : this.discount && this.discount.partner && this.discount.partner.city && this.discount.partner.city.name
    },
    getDateTime () {
      return this.discount && this.discount.datetime
    },
    getTimezone () {
      return this.discount && this.discount.partner && this.discount.partner.city && this.discount.partner.city.timezone
    }
  },
  methods: {
    goTo () {
      if (this.discount && this.discount.slug) {
        const route = { name: 'community-discount-slug', params: { slug: this.discount.slug } }
        const localRoute = this.$mRouter.getLocalRoute(route)
        this.$track.linkClicked('discountListItem', 'button', { linkUrl: localRoute.href })
        this.$mRouter.pushLocalRoute(route)
      } else {
        const route = { name: 'visa-debit-card-discounts-explore-discounts' }
        const localRoute = this.$mRouter.getLocalRoute(route)
        this.$track.linkClicked('discountListItem', 'button', { linkUrl: localRoute.href })
        this.$mRouter.pushLocalRoute(route)
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
</style>
